var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.27 22c-.385 0-1.155 0-1.54-.388L2.578 5.3c-.77-.777-.77-1.942 0-2.718.77-.777 1.923-.777 2.692 0l16.154 16.31c.77.777.77 1.942 0 2.719-.384 0-.77.388-1.154.388z",
    fill: "var(--color-primary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.115 22c-.384 0-1.153 0-1.538-.388-.77-.777-.77-1.942 0-2.719L18.73 2.583c.769-.777 1.923-.777 2.692 0 .77.776.77 1.941 0 2.718L5.27 21.611S4.5 22 4.115 22z",
    fill: "var(--color-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8d62710b4bca4b6207c7ae7a7a4c91e8.svg";
export { ForwardRef as ReactComponent };